import axios from 'axios';
import apiConfig from '../../api.config';

export default async function invoiceTemplateDeleteFile(hotelId, chainId, type) {
  const {
    host,
    URIs: { invoiceTemplateDeleteFile },
  } = apiConfig;

  const uri = `${host}${invoiceTemplateDeleteFile}`
    .replace(':chainId', chainId)
    .replace(':hotelId', hotelId)
    .replace(':type', type);

  return await axios.delete(uri).then(res => res.data);
}
